/* 
 * photos - jQuery Plugin
 * Version  : 1.0 (2017/02/20)
 */
;(function($){
	$.fn.navi = function(){
		var $target     = $(this);
		var isMobile    = LIB.WINDOW.type == 'xxs' || LIB.WINDOW.type == 'xs' ? true : false;
		var isOpen      = false;
		var position    = undefined;
		
		function _init(){
			_naviPosition();
			
			$(window).scroll(function(){
				_naviPosition();
			});
			$(window).resize(function(){
				isMobile = LIB.WINDOW.type == 'xxs' || LIB.WINDOW.type == 'xs' ? true : false;
				position = undefined;
				_naviPosition();
			});
			if('ontouchstart' in window) $(window).on('touchmove',function(){_naviPosition();});
			
			$('#GlobalNavi p').on('click', function(){
				if($(this).hasClass('close')){
					_hide();
				}else{
					_show();
				}
			});
		};
		function _naviPosition(){
			var footerPosition = $('#Footer').offset();
			
			if(LIB.WINDOW.scroll + LIB.WINDOW.height > footerPosition.top){
				if(position != 'bottom'){
					$target.css({'position':'absolute', 'top':'auto', 'bottom':$('#Footer').outerHeight(), 'left':0});
					position = 'bottom';
				}
			}else if((LIB.WINDOW.scroll + LIB.WINDOW.height) < $('#Visual').height() + $target.outerHeight(true) - 20){
				if(position != 'top'){
					$target.css({'position':'absolute', 'top':$('#Visual').height() - 20, 'bottom':'auto', 'left':0});
					position = 'top';
				}
			}else{
				if(position != 'fix'){
					$target.css({'position':'fixed', 'top':'auto', 'bottom':-1});
					position = 'fix';
				}
				$target.css({'left':-$(window).scrollLeft()});
			}
			
			_hide();
		}
		function _show(){
			if(!isMobile) return false;
			if(isOpen)    return false;
			
			isOpen = true;
			
			$('#Content').addClass('isNaviOpen');
			$target.find('p').addClass('close')
			$target.find('p strong').text('close');
			$target.find('.navi').css({height: $target.find('.navi ul').outerHeight()});
		}
		function _hide(){
			if(!isMobile) return false;
			if(!isOpen)   return false;
			
			isOpen = false;
		
			$('#Content').removeClass('isNaviOpen');
			$target.find('p').removeClass('close')
			$target.find('p strong').text('menu');
			$target.find('.navi').css({height: 0});
		}
		
		_init();
	};
})(jQuery);